import { useState } from "react";
import { toast } from "sonner";
import { Send, Mail } from "lucide-react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export default function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error("Please fill in your name, email and message");
      return;
    }
    setSending(true);
    try {
      await api.post("/messages", form);
      toast.success("Message sent! We'll get back to you soon. 💌");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Couldn't send your message");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="brut-card p-6 sm:p-8" data-testid="contact-form">
      <span className="font-accent text-3xl text-sky">get in touch</span>
      <h2 className="font-display font-bold text-3xl sm:text-4xl flex items-center gap-2">
        <Mail className="w-8 h-8 text-bubble" /> Send a message
      </h2>
      <p className="text-ink/60 text-lg mt-1 mb-6">Questions, custom requests, or just to say hi.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className="font-display font-semibold text-sm">Your name</label>
          <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="brut-input mt-1" data-testid="contact-name" />
        </div>
        <div>
          <label className="font-display font-semibold text-sm">Email</label>
          <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="brut-input mt-1" data-testid="contact-email" />
        </div>
      </div>
      <div className="mt-4">
        <label className="font-display font-semibold text-sm">Message</label>
        <Textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="brut-input mt-1 min-h-32" data-testid="contact-message" />
      </div>
      <button type="submit" disabled={sending} className="brut-btn bg-bubble text-white text-lg mt-5" data-testid="contact-submit">
        {sending ? "Sending…" : <>Send message <Send className="w-5 h-5" /></>}
      </button>
    </form>
  );
}
